import { ClipboardModule } from '@angular/cdk/clipboard'
import { Component, inject, input, signal, viewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule, MatIconButton } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Subscription, timer } from 'rxjs'
import { SnackbarService } from '../../../services'

@Component({
  selector: 'lib-copy-button',
  imports: [MatButtonModule, MatIconModule, ClipboardModule, MatTooltipModule],
  templateUrl: './copy-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './copy-button.component.scss',
})
export class CopyButtonComponent {
  readonly snackbar = inject(SnackbarService)

  /**
   * Content to be copied
   */
  readonly content = input<string | undefined>('')

  readonly icon = input('content_copy')
  readonly small = input<boolean>(false)

  readonly copyDone = signal(false)
  private resetSub?: Subscription

  readonly btn = viewChild.required(MatIconButton)

  copy() {
    this.btn()._elementRef.nativeElement.click()
  }

  copied(success: boolean) {
    if (success) {
      this.snackbar.showSuccess('Kopiert')

      this.resetSub?.unsubscribe()
      this.copyDone.set(true)
      // reset icon after 2 seconds
      this.resetSub = timer(2000).subscribe(() => this.copyDone.set(false))
    } else {
      this.snackbar.showError('Fehler beim Kopieren')
    }
  }
}
